export default __webpack_public_path__ + "static/media/Badge3.eb1277f0.png";